import VueRouter from 'vue-router';
import { getRoutes } from "./routes";
/**
 * Will scroll the view to top when route changes
 **/
var scrollToTop = function () {
    return { x: 0, y: 0 };
};
export var getRouter = function (configuration) { return new VueRouter({
    mode: 'history',
    routes: getRoutes(configuration),
    base: process.env.VIRTUAL_PATH,
    linkActiveClass: 'is-active',
    scrollBehavior: scrollToTop
}); };
